import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { GET_GROUPS } from '../get-groups';
import { createGroupAPI } from './api';

export function useCreateGroup(onSuccess) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const mutation = useMutation((group) => createGroupAPI(group), {
    onSuccess: () => {
      queryClient.invalidateQueries([GET_GROUPS, tenantId]);
      openModal({
        modalType: 'NotificationModal',
        modalProps: { type: 'success', description: 'createGroupSuccess' },
      });
      if (onSuccess) onSuccess();
    },
    onError: () => {
      openModal({
        modalType: 'NotificationModal',
        modalProps: { type: 'error', description: 'createGroupFail' },
      });
    },
  });

  return {
    ...mutation,
  };
}

